<div class="m-2 w-50 alert alert-{{messageStatus}}" role="alert" [hidden]="hideMessage || !responseMessage">
    {{responseMessage}}
    <button type="button" (click)="hideResponseMessage()" name="cancel" class="close" aria-label="Close"><span aria-hidden="true">×</span></button>
</div>
